import { Box, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DrawerContentContainer = styled(Box)(({ alignment = 'center', theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: alignment,
  gap: theme.spacing(2),
  height: '100%',
  width: '100%',
}));

export const TitleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.colors.softGray,
  padding: theme.spacing(1, 2),
  borderRadius: theme.spacing(1),
  width: '100%',
  minHeight: '46px',
  height: 'fit-content',
}));

export const TitleTextField = styled(TextField)(({ theme }) => ({
  width: 'fit-content',
  '& .MuiOutlinedInput-root': {
    margin: 0,
    '& fieldset': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      ...theme.typography.bodyRegular,
      color: theme.colors.gray,
      textAlign: 'right',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      height: 'fit-content',
      width: 'fit-content',
      minWidth: '100px',
    },
  },
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.colors.softGray,

  borderRadius: theme.spacing(1),
  width: '100%',
}));

export const DaysContainer = styled(Box)({
  display: 'flex',
  alignSelf: 'center',
  width: '100%',
  justifyContent: 'space-between',
  gap: '8px',
});

export const ErrorMessage = styled(Box)(({ theme }) => ({
  ...theme.typography.bodyRegular,
  color: theme.colors.red,
  width: '100%',
  padding: theme.spacing(1),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
  '& > button': {
    width: '100%',
  },
}));
